import Capitalize from '@/filters/capitalize'
import Time from '@/filters/time'
import PhoneNumber from '@/filters/phoneNumber'
import DateFilter from '@/filters/date'
import LocalDateTimeFilter from '@/filters/localDateTime'
import NoValue from '@/filters/noValue'
import Weight from '@/filters/weight'
import ToLower from '@/filters/toLower'
import BusinessDays from '@/filters/businessDays'
import FormatCurrency from '@/filters/formatCurrency'

export default {
  install (Vue, options) {
    Vue.filter(Capitalize.name, Capitalize.filter)
    Vue.filter(Time.name, Time.filter)
    Vue.filter(PhoneNumber.name, PhoneNumber.filter)
    Vue.filter(DateFilter.name, DateFilter.filter)
    Vue.filter(LocalDateTimeFilter.name, LocalDateTimeFilter.filter)
    Vue.filter(NoValue.name, NoValue.filter)
    Vue.filter(Weight.name, Weight.filter)
    Vue.filter(ToLower.name, ToLower.filter)
    Vue.filter(BusinessDays.name, BusinessDays.filter)
    Vue.filter(FormatCurrency.name, FormatCurrency.filter)
  }
}

